import PropTypes from "prop-types";
import Head from "next/head";
import ListingBadge from "components/ListingBadge";
import cn from "classnames";
import styles from "./style.module.scss";

const SquarefootRecommendedListingCard = ({
  listing,
  eager,
  onClick,
  className,
  mode,
}) => {
  const image = listing.imageUrl || "/nextpublic/defaultImage.png";
  const classNames = cn(
    styles.card,
    { [styles.ice]: mode === "ice" },
    className
  );
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <li className={classNames} onClick={onClick} onKeyPress={() => {}}>
      <div className={styles.listingCardImageWrapper}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img alt="listing" className={styles.listingCardImage} src={image} />
        {eager && (
          <Head>
            <link rel="preload" href={image} as="image" importance="high" />
          </Head>
        )}
        <ListingBadge badgeText="FEATURED" type="sfRecommended" />
      </div>
      <div className={styles.inner}>
        <p className={styles.title}>{listing.title}</p>
        <p className={styles.details}>{listing.detail}</p>
        <p className={styles.subtitle}>{listing.subtitle}</p>
      </div>
    </li>
  );
};

SquarefootRecommendedListingCard.propTypes = {
  eager: PropTypes.bool,
  listing: PropTypes.shape({
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    detail: PropTypes.string,
    badgeText: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  mode: PropTypes.string,
};

SquarefootRecommendedListingCard.defaultProps = {
  eager: true,
  onClick: () => {},
  className: "",
  mode: "m",
};

export default SquarefootRecommendedListingCard;
